import React from "react";

function StockSummaryCards({ items }) {
  return (
    <div className="stock-kpi-grid" aria-label="Stock summary">
      {items.map((item) => (
        <div className="stock-kpi-card" key={item.key}>
          <span className="stock-kpi-label">{item.label}</span>
          <strong>{item.value}</strong>
          {item.hint ? <small>{item.hint}</small> : null}
        </div>
      ))}
    </div>
  );
}

export default StockSummaryCards;
